var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 22",
    fill: "#FFC90A",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.407 7.112c-4.167 0-7.544 3.254-7.544 7.266 0 4.013 3.377 7.266 7.544 7.266s7.543-3.253 7.543-7.266c-.003-4.012-3.38-7.266-7.543-7.266Zm1.374 6.019c-.021.102-.092.204-.183.334-.113.158-.253.358-.313.615-.102.428-.07.913-.031 1.43.035.47.07 1.008-.04 1.31-.115.323-.48.468-.786.468a.973.973 0 0 1-.366-.07.654.654 0 0 1-.379-.398c-.133-.369-.095-.829-.05-1.317.04-.45.082-.917-.017-1.364-.07-.323-.235-.565-.369-.759-.049-.07-.123-.179-.133-.217-.095-.408-.028-.802.19-1.118.2-.291.52-.485.896-.544.094-.014.19-.025.28-.025.426 0 .795.162 1.044.457.264.309.355.734.257 1.198Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.118 6.96c.06-1.223.186-2.379.442-2.793.612-.994 1.617-1.578 2.759-1.602h.119a3.25 3.25 0 0 1 2.786 1.574c.278.446.408 1.588.468 2.825.917.38 1.753.91 2.466 1.56.018-1.328.035-2.895.014-3.208C14.003 2.677 11.727.439 8.993.22a8.512 8.512 0 0 0-.51-.024C6.995.183 5.677.647 4.574 1.58c-1.096.928-1.813 2.29-1.925 3.654-.025.288-.025 1.954-.021 3.31a8.31 8.31 0 0 1 2.49-1.585Z"
  })));
};

export default SvgLock;